import { useMyPersonIsManager } from "@/modules/common/entities/my-person";

export function useFilterByIsManager() {
  const { isManager } = useMyPersonIsManager();

  return (item: { requiredIsManager?: boolean }) => {
    if (!item.requiredIsManager) {
      return true;
    }

    return isManager;
  };
}
